import React, { useEffect, useState } from "react";
import { filterNonNumeric, toEnglishNumber, toPersianNumber } from "../utils/numberConversion";
import { toast } from "react-toastify";
import { api } from "../utils/gashtaltAPI";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent, ModalFooter,
    ModalHeader,
    ModalOverlay, Table,
    TableContainer, Tbody, Td, Thead, Tr
} from "@chakra-ui/react";
import FileInput from "./FileInput";

function FileModal({ isOpen, onClose, bundle }) {
    const [name, setName] = useState('');
    const [price, setPrice] = useState(0);

    useEffect(() => {
        setName('');
        setPrice(0);
    }, [isOpen]);

    const handlePrice = (e) => {
        setPrice(toPersianNumber(filterNonNumeric(e.target.value)));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // eslint-disable-next-line no-mixed-operators
        if (!name || name === "" || !price && price !== 0) {
            toast.error("فرم را کامل کنید!", {
                position: "bottom-right"
            });
            return;
        }
        const file = (e.target.files[0]);

        // Show "در حال بارگزاری" toast
        const toastId = toast.info("در حال بارگزاری...", {
            position: "bottom-right",
            autoClose: false,
            closeButton: false,
        });

        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("name", name);
            formData.append("price", toEnglishNumber(price));

            const response = await api.post(`/api/bundle/${bundle?.id}/files/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            // Update toast to success
            toast.update(toastId, {
                render: response.data.message,
                type: "success",
                autoClose: 3000,
            });
            onClose();
        } catch (error) {
            // Update toast to error
            const errorMessage = error.response?.data?.message || "خطایی رخ داد!";
            toast.update(toastId, {
                render: errorMessage,
                type: "error",
                autoClose: 5000,
            });

            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>افزودن فایل </ModalHeader>
                <ModalCloseButton />
                <form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    <ModalBody className="exam-modal">
                        <div className="custom-input-group">
                            <label>نام فایل</label>
                            <input
                                type="text"
                                className={`form-control ${name?.length > 32 ? 'invalid' : ''}`}
                                value={name}
                                onChange={(e) => {
                                    setName(toPersianNumber(e.target.value));
                                }}
                                placeholder="نام فایل"
                            />
                            <p className={`form-error ${name?.length > 32 ? 'visible' : 'hidden'}`}>
                                نام فایل نمی تواند بیشتر از ۳۲ کاراکتر باشد.
                            </p>
                        </div>
                        <div className="custom-input-group">
                            <label>قیمت</label>
                            <input
                                type="text"
                                className='form-control'
                                value={price}
                                onChange={handlePrice}
                                placeholder="قیمت( به تومان)"
                                autoComplete="true"
                            />
                        </div>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                            بستن
                        </Button>
                        <FileInput
                            text={'اپلود فایل و ثبت'}
                            className={'btn-outline-blue'}
                            onChange={(e) => {
                                handleSubmit(e);
                            }}
                        />
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
}

export default FileModal;